import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function ClientDetails({ label, clientName, organizationId }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={clientName}
                organizationId={organizationId}
            />
        </EuiFlexItem>
    );
}
